// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".ant-drawer-content-wrapper{max-width:1184px}.ant-drawer-content-wrapper .ant-drawer-wrapper-body{background:var(--pult-bg)}.ant-drawer-content-wrapper .ant-drawer-body{padding:0}.drawer-header{display:flex;background:var(--pult-surface);justify-content:space-between;align-items:center;padding:17px 24px}.drawer-header .title{color:var(--pult-text);font-size:30px;font-weight:600}.drawer-header .drawer-body{padding:24px}", ""]);
// Exports
module.exports = exports;
